const files = require.context('.', false, /\.js$/)
let router = []

files.keys().forEach(key => {
  if (key === './index.js' || key === './routes.js') return
  router = router.concat(files(key).default)
})

// routes
export default router



// WEBPACK FOOTER //
// ./src/router/routes.js